module.exports = __webpack_public_path__ + "img/logo.04da7677.svg";